// Part of the SPARKL educational activity system, Copyright 2020 by Pepper Williams

// fn for returning the "value" for a grade -- what we use to order the grades
U.grade_value = function(grade) {
	return vapp.$store.state.grades.findIndex(g=>g==grade)
}

// fn for determining if the given object o, which must include a grade_low and grade_high parameter, "includes" the given grade
U.grades_include = function(o, grade_low, grade_high, flag) {
	// if object doesn't have a grade_low or grade_high, return false
	if (empty(o.grade_low) || empty(o.grade_high)) return false
	let o_grade_low = o.grade_low
	let o_grade_high = o.grade_high

	// clear up K/KG confusion
	if (vapp.$store.state.grades.includes('K')) {
		if (grade_low == 'KG') grade_low = 'K'
		if (grade_high == 'KG') grade_high = 'K'
	} else {
		if (grade_low == 'K') grade_low = 'KG'
		if (grade_high == 'K') grade_high = 'KG'
	}

	// try to get the index of the given grade_low and o's grade_low and grade_high from the store's grades array; if any not found return false
	let grade_low_index = U.grade_value(grade_low)
	let o_grade_low_index = U.grade_value(o_grade_low)
	let o_grade_high_index = U.grade_value(o_grade_high)

	if (grade_low_index == -1) return false
	if (o_grade_low_index == -1) return false
	if (o_grade_high_index == -1) return false

	// grade_high is optional; if not provided, base just on grade_low
	if (!grade_high) {
		return (grade_low_index >= o_grade_low_index && grade_low_index <= o_grade_high_index)
	} else {
		// if we have a grade_low and a grade_high...
		let grade_high_index = U.grade_value(grade_high)
		if (empty(grade_high_index)) return false

		// if we're told that the object values have to *fully include* both grade_low *and* grade_high...
		if (flag == 'fully_include') {
			// return false if o_grade_lo is < grade_lo
			if (grade_low_index < o_grade_low_index) return false
			// return false if o_grade_hi is > grade_hi
			if (grade_high_index > o_grade_high_index) return false
			// otherwise both are in range, so return true
			return true

		} else {
			// return false if grade_high is < o_grade_low
			if (grade_high_index < o_grade_low_index) return false
			// return false if grade_low is > o_grade_high
			if (grade_low_index > o_grade_high_index) return false
			// else return true
			return true
		}
	}
}


// Refactor so that it just uses the color
// fn for consistently coloring things
// U.subject_tile_css = function(o) {
// 	if (o.color) {
// 		return 'k-list-color-' + o.color
// 	}
// 	if (o.subject && vapp.$store.state.subjects[o.subject]) {
// 		return 'k-framework-color-' + vapp.$store.state.subjects[o.subject].color
// 	}

// 	if (!empty(o.title)) {
// 		return vapp.color_from_string(o.title)
// 	}

// 	return vapp.color_from_string(o + '')
// }

U.shade_color = function(color, variant) {
	// if there is no variant, we don't want a shade, just the base color
	if (!color || (color && color.length < 3)) return ''
	if (!variant) return color
	// Helper functions
	const hslToHex = (h, s, l) => {
		l /= 100;
		const a = s * Math.min(l, 1 - l) / 100;
		const f = n => {
			const k = (n + h / 30) % 12;
			const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
			return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and pad with zeros if needed
		};
		return `#${f(0)}${f(8)}${f(4)}`;
	}

	const hex_to_rgb = (color) => {
		color = color.replace(/^#/, '')
		// 3 character rgb probably won't happen
		if (color.length === 3) color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2]
		let [r, g, b] = color.match(/.{2}/g);
		// normalized RGB
		[r, g, b] = [parseInt(r, 16) / 255, parseInt(g, 16) / 255, parseInt(b, 16) / 255]
		return [r, g, b]
	}

	const [r, g, b] = hex_to_rgb(color)

	const max = Math.max(r, g, b)
	const min = Math.min(r, g, b);

	let h, s, l = (max + min) / 2;
	
	if(max == min){
		h = s = 0;
	} else {
		const d = max - min;
		s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
		switch(max) {
			case r: h = (g - b) / d + (g < b ? 6 : 0); break;
			case g: h = (b - r) / d + 2; break;
			case b: h = (r - g) / d + 4; break;
		}
		h /= 6;
	}
	
	s = s*100;
	s = Math.round(s);
	l = l*100;
	l = Math.round(l);
	h = Math.round(360*h);

	let hex = ''
	if (variant === 'light') {
		// more towards 1 is lighter
		const weight = .9
		hex = hslToHex(h, s, l + (100 - l) * weight)
	} else if (variant === 'med_dark' || variant === 'text') {
		// more towards 1 is darker
		const weight = .2
		hex = hslToHex(h, s, l * (1 - weight))
	} else if (variant === 'dark' || variant === 'border') {
		// more towards 1 is darker
		const weight = .35
		hex = hslToHex(h, s, l * (1 - weight))
	} else if (variant === 'darkest') {
		// more towards 1 is darker
		const weight = .5
		hex = hslToHex(h, s, l * (1 - weight))
	}
	return hex.toUpperCase()
}

// MC: variant can be empty, light, med_dark, dark, darkest, text, border, or border-text
U.get_collection_color = function (o, variant)  {
	let color = o.color
	if (variant === 'border-text') {
		return ({
			'border-color': `${color} !important`,
			'color': `${color} !important`
		})
	}

	// default collection
	if ((!o.subject || !vapp.$store.state.subjects[o.subject]) && !color) {
		if (!o.title) color = vapp.site_config.swatches[Math.floor(Math.random()*vapp.site_config.swatches.length)][0]
		// Generate random color based on title
		else {
			const s = o.title
			let n = 2
			for (let i = 0; i < s.length; ++i) {
				n += s.charCodeAt(i)
			}
			n = n * 1
			n = (n % 16) + 1
			color = vapp.site_config.swatches[n-1][0]
		}
	} else if (o.subject in vapp.$store.state.subjects && !color)  {
		// these should be the auto-generated colors
		const subject_color = vapp.$store.state.subjects[o.subject].color
		color = U.shade_color(subject_color, variant)
	} else {
		color = U.shade_color(color, variant)
	}
	return color
}

U.collection_color_style = function(o, variant) {
	if (variant === 'border-light-bgd') {
		const color1 = U.get_collection_color(o, 'border')
		const color2 = U.get_collection_color(o, 'light')
		return ({
			'border-color': `${color1} !important`,
			'background-color': `${color2} !important`,
		})
	}

	const color = U.get_collection_color(o, variant)
	if (variant === 'border') {
		return ({
			'border-color': `${color} !important`,
		})
	} else if (variant === 'text') {
		return ({
			'color': `${color} !important`
		})
	}
	return (
		{
			'background-color': `${color} !important`
		}
	)
}

U.get_contrast_color = function(color, variant) {
	// Convert hex color to RGB
	if (variant === 'light') {
		color = U.shade_color(color, 'light')
		// MC: if it is auto-generated or a "legacy color", we can return and use existing styles
		if (!color) return
	} else if (variant === 'dark') {
		color = U.shade_color(color, 'dark')
		// MC: if it is auto-generated or a "legacy color", we can return and use existing styles
		if (!color) return
	}
	let r = parseInt(color.substr(1, 2), 16);
	let g = parseInt(color.substr(3, 2), 16);
	let b = parseInt(color.substr(5, 2), 16);

	let a = [r, g, b].map(function (v) {
		v /= 255;
		return v <= 0.03928
		? v / 12.92
		: Math.pow( (v + 0.055) / 1.055, 2.4 );
	});
	const luminance_white = 1.0
	const luminance_black = 0.0
	const picker_color_luminance = a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
	let contrast_white = (luminance_white + 0.05) / (picker_color_luminance + 0.05);
	let contrast_black = (picker_color_luminance + 0.05) / (luminance_black + 0.05);
	return contrast_black > contrast_white ? '#000000' : '#FFFFFF';
}


class Learning_Progression {
	constructor(data) {
		if (empty(data)) data = {}

		sdp(this, data, 'fully_loaded', false)

		sdp(this, data, 'lp_id', 0)
		sdp(this, data, 'agency_sanctioned', false)
		sdp(this, data, 'updated_at', '')
		sdp(this, data, 'case_identifier', '')
		sdp(this, data, 'course_code', '')		// called a 'course_code' for legacy reasons; used for all collections, be they courses, repos, or 'my' collections
		sdp(this, data, 'state_course_code', '')
		sdp(this, data, 'title', '')
		sdp(this, data, 'subject_case_identifier', '')
		sdp(this, data, 'course_case_identifier', '')
		sdp(this, data, 'description', '')
		sdp(this, data, 'grade_low', '')
		sdp(this, data, 'grade_high', '')
		sdp(this, data, 'subject', '')
		sdp(this, data, 'sparkl_origin_override', '')
		sdp(this, data, 'active', 'yes')	// when set to 'no', only admins can see it
		sdp(this, data, 'owner_id', 0)
		sdp(this, data, 'repo_category', '')
		sdp(this, data, 'subscription_only', false)

		sdp(this, data, 'subscription_code', '')	// allows users to share/subscribe to 'my' collections

		// MC: Just for my collection
		if (data.color === 'default') this.color = '#424242'
		// Auto Generate a color based on title and populate the color field
		else if (!data.color && !data.subject && data.title) {
			const s = data.title
			let n = 2
			for (let i = 0; i < s.length; ++i) {
				n += s.charCodeAt(i)
			}
			n = n * 1
			n = (n % 16) + 1
			this.color = vapp.site_config.swatches[n-1][0]
		// This is for when the lp.color comes in as 1, 2, 3, 4..., should match up with the swatches
		// This only applies to legacy LPs
		} else if (data.color && data.color !== '' && data.color.length < 3) {
			// type conversion here
			if (vapp.site_config.swatches[data.color-1]) {
				this.color = vapp.site_config.swatches[data.color-1][0]
			} else {
				this.color = '#424242'
			}
		// If there is no color, but there is a subject, then we can set the color to the subject
		} else if (!data.color && data.subject && data.subject != '-' && vapp.$store.state.subjects[data.subject]) {
			this.color = vapp.$store.state.subjects[data.subject].color
		} else {
			sdp(this, data, 'color', '')
		}


		// determine collection_type
		if (!empty(data.collection_type)) {
			sdp(this, data, 'collection_type', 'my', ['my', 'course', 'repo', 'pd'])
		
		// deal with some legacy Henry/Inspire things...
		} else if (data.course_code && data.course_code*1 > 90000 && !data.course_code.includes('.')) {
			this.collection_type = 'pd'
		} else if (data.course_code && data.course_code[0] == 'C') {
			this.collection_type = 'repo'
		
		// and by default collection_type is 'course'
		} else {
			this.collection_type = 'course'
		}
		// console.log(`${this.collection_type} - ${data.course_code}: ${data.title}`)

		// lp_layout; default to 'map' for course collections and 'tree' otherwise
		if (!empty(data.lp_layout)) {
			sdp(this, data, 'lp_layout', 'tree', ['tree', 'map'])	// 'tree' = "content repository" -- content shown in a tree structure; 'map' = "curriculum map" -- units shown in a table
		} else if (this.collection_type == 'course') {
			this.lp_layout = 'map'
		} else {
			this.lp_layout = 'tree'
		}

		// cmap_specified is sent in by get_all_courses, and tells us whether or not the curriculum map has been specified at all yet (separate from whether the course is marked as active)
		sdp(this, data, 'cmap_specified', false)

		// normalize subject capitalization, unless the first two letters are both capital (e.g. CTAE, ESOL)
		if (this.subject.search(/^[A-Z][A-Z]/) == -1) {
			this.subject = U.capitalize_words(this.subject)
		}

		// repo_category and sequence for repo and pd types (which are shown together)
		if (this.collection_type == 'repo' || this.collection_type == 'pd' || this.collection_type == 'my') {
			// PW: ignore the legacy 'Professional Development Collections' category
			if (data.repo_category && data.repo_category != 'Professional Development Collections') this.repo_category = data.repo_category
			// MC: PD Categories are now stored at {order}_pd
			// else if (this.collection_type == 'pd') this.repo_category = 'Professional Development Collections'	// put pd collections into this category by default
			else this.repo_category = ''

			sdp(this, data, 'sequence', 0)	// for resource collections: used to order collections
		}

		// used in Collection.vue; removed before saving
		sdp(this, data, 'full_description_showing', false)
		sdp(this, data, 'full_description_height', -1)
		sdp(this, data, 'shifted_for_lesson', false)
		sdp(this, data, 'standards_aligned_assets_loading', false)
		
		this.terms = []
		this.units = []
		if (!empty(data.terms)) {
			for (let t of data.terms) {
				// legacy LP's have units saved in terms; deal with those here
				if (!empty(t.units)) {
					// assume these terms are quarters -- 9 weeks
					this.terms.push({
						title: t.title,
						duration: '9',
					})
					for (let u of t.units) {
						this.units.push(new LP_Unit(u))
					}
				} else {
					// "new" terms just have titles and duration; assume 9 weeks if not given
					let term = {}
					sdp(term, t, 'title', '')
					sdp(term, t, 'duration', '9')
					this.terms.push(term)
				}
			}
		}

		// now LP units
		this.total_weeks = 0	// count total_weeks from units
		if (!empty(data.units)) {
			for (let u of data.units) {
				if (!isNaN(u.duration*1)) this.total_weeks += u.duration*1
				this.units.push(new LP_Unit(u))
			}
		}

		// flags for whether or not to use terms, unit numbers, and unit time intervals
		sdp(this, data, 'use_terms', (vapp.site_config.default_new_collection_arrange_by_terms == 'yes'))
		sdp(this, data, 'use_unit_numbers', (vapp.site_config.default_new_collection_specify_unit_numbers == 'yes'))
		sdp(this, data, 'use_unit_intervals', (this.collection_type == 'course' && vapp.site_config.default_new_collection_specify_unit_intervals == 'yes'))
		// label to use for the collection of units
		sdp(this, data, 'unit_collection_title', vapp.site_config.default_new_collection_scope_and_sequence_label)

		// // flags for whether or not to use terms, unit numbers, and unit time intervals
		// sdp(this, data, 'use_terms', false)
		// sdp(this, data, 'use_unit_numbers', true)
		// sdp(this, data, 'use_unit_intervals', false)

		// // label to use for the collection of units, if use_terms is false
		// sdp(this, data, 'unit_collection_title', 'Curriculum Map')

		// course-wide resources and assessment resources for the course; order by ids if we get them
		this.course_wide_resources = []
		if (!empty(data.course_wide_resources)) {
			if (!empty(data.course_wide_resources_ids)) {
				for (let id of data.course_wide_resources_ids) {
					let item = data.course_wide_resources.find(x=>x.resource_id == id)
					if (!item) {
						console.log('error ordering course_wide_resources array')
					} else {
						this.course_wide_resources.push(new Resource(item))
					}
				}
			} else {
				for (let r of data.course_wide_resources) this.course_wide_resources.push(new Resource(r))
			}
		}
		this.assessment_resources_general = []
		if (!empty(data.assessment_resources_general)) {
			if (!empty(data.assessment_resources_general_ids)) {
				for (let id of data.assessment_resources_general_ids) {
					let item = data.assessment_resources_general.find(x=>x.resource_id == id)
					if (!item) {
						console.log('error ordering assessment_resources_general array')
					} else {
						this.assessment_resources_general.push(new Resource(item))
					}
				}
			} else {
				for (let r of data.assessment_resources_general) this.assessment_resources_general.push(new Resource(r))
			}
		}
		this.assessment_resources_annotated_examples = []
		if (!empty(data.assessment_resources_annotated_examples)) {
			if (!empty(data.assessment_resources_annotated_examples_ids)) {
				for (let id of data.assessment_resources_annotated_examples_ids) {
					let item = data.assessment_resources_annotated_examples.find(x=>x.resource_id == id)
					if (!item) {
						console.log('error ordering assessment_resources_annotated_examples array')
					} else {
						this.assessment_resources_annotated_examples.push(new Resource(item))
					}
				}
			} else {
				for (let r of data.assessment_resources_annotated_examples) this.assessment_resources_annotated_examples.push(new Resource(r))
			}
		}
		this.assessment_resources_sample_items = []
		if (!empty(data.assessment_resources_sample_items)) {
			if (!empty(data.assessment_resources_sample_items_ids)) {
				for (let id of data.assessment_resources_sample_items_ids) {
					let item = data.assessment_resources_sample_items.find(x=>x.resource_id == id)
					if (!item) {
						console.log('error ordering assessment_resources_sample_items array')
					} else {
						this.assessment_resources_sample_items.push(new Resource(item))
					}
				}
			} else {
				for (let r of data.assessment_resources_sample_items) this.assessment_resources_sample_items.push(new Resource(r))
			}
		}

		// PW: brought over from Henry: set to true if a teacher has chosen to view activities for an origin teacher; used to determine whether or not to show activity counts on course "tiles"
		this.viewing_origin_teacher_activities = false

		// PW: brought over from Henry: boolean to tell us whether we've loaded posts for the lp
		this.forum_loaded = false

		// resource_ids for resource collection(s) -- e.g. resources loaded via thin common cartridges
		sdp(this, data, 'resource_collection_ids', [])

		// resource_collections and pd_resources may also be sent to the client; but we don't save these
		sdp(this, data, 'resource_collections', [])
		sdp(this, data, 'pd_resources', [])
		
		// a resource_collection is a special resource, with:
		// resource_id: a unique id (e.g. the manifest identifier from the common cartridge file)
		// description: title of the collection (e.g. "HMH Science 3rd Grade")
		// type: 'resource_collection'
		// collection_json: a big json object (with property names shortened for loading efficiency) specifying a tree-folder structure and resources.
		// Each item in collection_json may contain:
		//		t: title
		//		c: array of child items
		//		f: for an array of child items, the identiFier (unique within the collection) for the "folder" (from the common cartridge file)
		//		r: resource_id of a resource (the resource will have its own table entry in the resources table)
		//		i: 1 if the resource is teacher-facing only
	}

	copy_for_save() {
		let o = $.extend(true, {}, this)
		delete o.fully_loaded
		delete o.viewing_origin_teacher_activities
		delete o.forum_loaded
		delete o.resource_collections
		delete o.pd_resources
		delete o.cmap_specified
		delete o.total_weeks

		// remove these things that are used in Collection.vue
		delete o.full_description_showing
		delete o.full_description_height
		delete o.shifted_for_lesson
		delete o.standards_aligned_assets_loading

		// SF: owner_id is injected into lp.data in get_learning_progression service
		delete o.owner_id

		o.units = []
		for (let unit of this.units) {
			o.units.push(unit.copy_for_save())
		}

		// remove full resource objects for course_wide and assessment resources; attach resource_ids instead
		delete o.course_wide_resources
		delete o.assessment_resources_general
		delete o.assessment_resources_annotated_examples
		delete o.assessment_resources_sample_items
		o.course_wide_resources_ids = []
		o.assessment_resources_general_ids = []
		o.assessment_resources_annotated_examples_ids = []
		o.assessment_resources_sample_items_ids = []
		for (let r of this.course_wide_resources) o.course_wide_resources_ids.push(r.resource_id)
		for (let r of this.assessment_resources_general) o.assessment_resources_general_ids.push(r.resource_id)
		for (let r of this.assessment_resources_annotated_examples) o.assessment_resources_annotated_examples_ids.push(r.resource_id)
		for (let r of this.assessment_resources_sample_items) o.assessment_resources_sample_items_ids.push(r.resource_id)

		return o
	}

	vue_route(unit_route) {
		if (empty(unit_route)) unit_route = 0
		
		return `/collection/${this.course_code}/${unit_route}`
		// if (this.collection_type == 'course') return `/course/${this.course_code}/${unit_route}`
		// if (this.collection_type == 'repo') return `/repo/${this.course_code}/${unit_route}`
		// if (this.collection_type == 'my') return `/mycollection/${this.course_code}/${unit_route}`
		return '/welcome'
	}

	user_is_lp_admin() {
		if (vapp.has_admin_right('lp.course.' + this.course_code)) return true

		// check based on subject
		if (vapp.has_admin_right('lp.subject.' + this.subject)) return true

		// check based on level
		if (U.grades_include(this, 'K') && vapp.has_admin_right('lp.level.Elementary')) return true
		if (U.grades_include(this, '1') && vapp.has_admin_right('lp.level.Elementary')) return true
		if (U.grades_include(this, '2') && vapp.has_admin_right('lp.level.Elementary')) return true
		if (U.grades_include(this, '3') && vapp.has_admin_right('lp.level.Elementary')) return true
		if (U.grades_include(this, '4') && vapp.has_admin_right('lp.level.Elementary')) return true
		if (U.grades_include(this, '5') && vapp.has_admin_right('lp.level.Elementary')) return true
		if (U.grades_include(this, '6') && vapp.has_admin_right('lp.level.Middle School')) return true
		if (U.grades_include(this, '7') && vapp.has_admin_right('lp.level.Middle School')) return true
		if (U.grades_include(this, '8') && vapp.has_admin_right('lp.level.Middle School')) return true
		if (U.grades_include(this, '9') && vapp.has_admin_right('lp.level.High School')) return true
		if (U.grades_include(this, '10') && vapp.has_admin_right('lp.level.High School')) return true
		if (U.grades_include(this, '11') && vapp.has_admin_right('lp.level.High School')) return true
		if (U.grades_include(this, '12') && vapp.has_admin_right('lp.level.High School')) return true

		// if we get to here, not an admin -- i.e. they can't edit the collection
		return false
	}

	user_can_view_lp() {
		// console.log('---- user_can_view_lp - ' + this.course_code)

		// admins can obviously view
		if (this.user_is_lp_admin()) return true

		if (vapp.has_admin_right('view_lp.course.' + this.course_code)) return true

		// check based on subject
		if (vapp.has_admin_right('view_lp.subject.' + this.subject)) return true

		// check based on level
		if (U.grades_include(this, 'K') && vapp.has_admin_right('view_lp.level.Elementary')) return true
		if (U.grades_include(this, '1') && vapp.has_admin_right('view_lp.level.Elementary')) return true
		if (U.grades_include(this, '2') && vapp.has_admin_right('view_lp.level.Elementary')) return true
		if (U.grades_include(this, '3') && vapp.has_admin_right('view_lp.level.Elementary')) return true
		if (U.grades_include(this, '4') && vapp.has_admin_right('view_lp.level.Elementary')) return true
		if (U.grades_include(this, '5') && vapp.has_admin_right('view_lp.level.Elementary')) return true
		if (U.grades_include(this, '6') && vapp.has_admin_right('view_lp.level.Middle School')) return true
		if (U.grades_include(this, '7') && vapp.has_admin_right('view_lp.level.Middle School')) return true
		if (U.grades_include(this, '8') && vapp.has_admin_right('view_lp.level.Middle School')) return true
		if (U.grades_include(this, '9') && vapp.has_admin_right('view_lp.level.High School')) return true
		if (U.grades_include(this, '10') && vapp.has_admin_right('view_lp.level.High School')) return true
		if (U.grades_include(this, '11') && vapp.has_admin_right('view_lp.level.High School')) return true
		if (U.grades_include(this, '12') && vapp.has_admin_right('view_lp.level.High School')) return true

		// if we get to here, can't view
		return false
	}

	user_is_subscribed_to_lp() {
		// this should be true if a) this collection is only available to subscribers, and b) the current user is subscribed
		// for (a), this means that either the collection is type 'my', or subscription_only is true
		if (!(this.collection_type == 'my' || this.subscription_only)) return false

		// MC: If the user is an admin and the collection isn't 'my', then it means that they are not 'subscribed'; they inherently have access to the repo
		if (vapp.user_info.role == 'admin' && this.collection_type == 'repo') return false

		// the collection owner owns the collection; they aren't subscribed
		if (this.owner_id == vapp.user_info.user_id) return false

		// return true if the user has a specific right to edit or view the collection
		if (vapp.has_specific_admin_right('lp.course.' + this.course_code)) return true
		if (vapp.has_specific_admin_right('view_lp.course.' + this.course_code)) return true
		return false
	}

	// this fn currently (12/2023) tells us if the lp was imported from Henry, so we can do some hacky things for demo purposes
	// WE SHOULD NOT USE THIS GOING FORWARD; use stuff in site_config, e.g. `if (site_config.app_name == 'HenryConnects')`
	lp_source() {
		if (this.course_code == Math.round(this.course_code*1)) return 'henry'
		return false
	}

	default_collection_id_for_collection_asset_mapping(user_id) {
		// return the user's default collection lp_id -- maps on to fn in learning_progression.php
		if (empty(user_id)) user_id = vapp.$store.state.user_info.user_id
		return `default_collection_${user_id}`
	}

	grade_band() {
		if (U.grades_include(this, 'K')) return 'Elementary'
		if (U.grades_include(this, '1')) return 'Elementary'
		if (U.grades_include(this, '2')) return 'Elementary'
		if (U.grades_include(this, '3')) return 'Elementary'
		if (U.grades_include(this, '4')) return 'Elementary'
		if (U.grades_include(this, '5')) return 'Elementary'
		if (U.grades_include(this, '6')) return 'Middle School'
		if (U.grades_include(this, '7')) return 'Middle School'
		if (U.grades_include(this, '8')) return 'Middle School'
		if (U.grades_include(this, '9')) return 'High School'
		if (U.grades_include(this, '10')) return 'High School'
		if (U.grades_include(this, '11')) return 'High School'
		if (U.grades_include(this, '12')) return 'High School'
	}

	collection_icon() {
		if (this.collection_type == 'course') return 'fas fa-chalkboard'
		else if (this.collection_type == 'repo') return 'fas fa-diagram-project'
		else if (this.collection_type == 'pd') return 'fas fa-user-graduate'
		else return 'fas fa-cubes-stacked'
	}

	static collection_id_for_empty_lp(course_code) {
		// for districts, we sometimes have "courses" that don't have learning progressions (e.g. "Study Skills"); use this as the collection_id in certain places
		// Learning_Progression.collection_id_for_empty_lp(this.course_code)
		return `9999999-${course_code}`
	}

	get_term_dates_for_unit(unit, term_mode, flag) {
		if (empty(vapp.$store.state.term_settings) || empty(vapp.$store.state.term_settings.weeks) || vapp.$store.state.term_settings.weeks.length == 0) return null

		let weeks = vapp.$store.state.term_settings.weeks

		let start_date_from_week_index = function(w) {
			// start with the start date of week w
			let week = weeks[Math.floor(w)]
			let d = week[0]
			let rem = w % 1
			if (rem > 0) {
				// add days for the remainder -- multiplied by n of days in this week
				let n = U.days_into_year(week[1]) - U.days_into_year(week[0])
				let rem_days = Math.ceil(rem * n)
				d = date.parse(d, 'YYYY-MM-DD')
				d.setDate(d.getDate() + rem_days)
				d = date.format(d, 'YYYY-MM-DD')
			}
			return d
		}

		let end_date_from_week_index = function(w) {
			// if week is 0, return the start of week 0 (shouldn't happen)
			if (w == 0) return weeks[0][0]

			let rem = w % 1
			if (rem == 0) {
				// if w is, e.g. 9 even, we want the end date of week 8 (w-1)
				// BUT, if there are too many weeks we don't want an overflow...
				if (!weeks[w-1]) return weeks[weeks.length-1][1]
				else return weeks[w-1][1]
			}

			// else start with the start date of week w
			let week = weeks[Math.floor(w)]
			let d = week[0]
			if (rem > 0) {
				// add days for the remainder -- multiplied by n of days in this week
				let n = U.days_into_year(week[1]) - U.days_into_year(week[0])
				let rem_days = Math.ceil(rem * n) - 1
				d = date.parse(d, 'YYYY-MM-DD')
				d.setDate(d.getDate() + rem_days)
				d = date.format(d, 'YYYY-MM-DD')
			}
			return d
		}

		// Example:
		// U1: 9 weeks: start is start of week 1, end is end of week 9
		// U2: 5 weeks: start is start of week 10, end is end of week 14
		// U3: 4.5 weeks: start is start of week 15, end is the wednesday of week 19
		// U4: 3.5 weeks: start is thursday of week 19, end is the end of week 22
		// etc.

		// by default we start with week 1 (0)...
		let w = 0
		// ... but if this is a half-year class, or we're doing a block schedule, adjust based on current term
		let total_weeks = this.total_weeks
		if (term_mode == 'block') total_weeks = total_weeks / 2
		if (total_weeks <= 18) {
			let current_term = vapp.$store.getters.current_term
			// if total_weeks is one term, start with the first week of the current term
			if (total_weeks <= 9) {
				if (current_term == 1) w = 0
				else if (current_term == 2) w = 9
				else if (current_term == 3) w = 18
				else if (current_term == 4) w = 27

			} else {
				// else total_weeks is one semester, so if we're in the second semester, start with the first week of term 3
				if (current_term >= 3) w = 18
			}
		}
		
		let start, end
		for (let u of this.units) {
			// if this is the unit we're interested in, set start
			if (u == unit) {
				start = start_date_from_week_index(w)
			}

			// as long as this unit has a numeric duration, move cursor to the end of the unit
			let ud = u.duration * 1
			// for blocks we divide duration by 2
			if (term_mode == 'block') ud = ud / 2
			if (!(isNaN(ud) || ud == 0)) {
				w += ud
			}

			// if this is the unit we're interested in, set end and break
			if (u == unit) {
				end = end_date_from_week_index(w)
				break
			}
		}

		if (empty(start) || empty(end)) return null
		
		if (flag == 'short') {
			start = date.format(date.parse(start, 'YYYY-MM-DD'), 'M/D')
			end = date.format(date.parse(end, 'YYYY-MM-DD'), 'M/D')
		}
		return [start, end]
	}

	// get standards-aligned assets for the whole collection
	get_standards_aligned_assets() {
		return new Promise((resolve, reject) => {
			let payload = {user_id: vapp.user_info.user_id, lesson_ids: [], resource_ids: []}

			// if we're already in the process of loading all assets for the collection, return
			if (this.standards_aligned_assets_loading) {
				resolve()
				return
			}

			for (let unit of this.units) {
				// if unit's assets are already loaded, skip the unit
				if (unit.standards_aligned_assets_loaded) continue

				// and if we don't have any assets to load, set unit.standards_aligned_assets_loaded = true and continue
				if (unit.standards_aligned_assets.length == 0) {
					unit.standards_aligned_assets_loaded = true
					continue
				}

				// get lists of assets to load
				for (let asset of unit.standards_aligned_assets) {
					if (asset.asset_type == 'lesson') payload.lesson_ids.push(asset.asset_id)
					else payload.resource_ids.push(asset.asset_id)
				}
			}

			// if nothing to load, we're done
			if (payload.lesson_ids.length == 0 && payload.resource_ids.length == 0) {
				resolve()
				return
			}

			// remove duplicates
			payload.lesson_ids = JSON.stringify([...new Set(payload.lesson_ids)])
			payload.resource_ids = JSON.stringify([...new Set(payload.resource_ids)])

			this.standards_aligned_assets_loading = true

			U.loading_start()
			U.ajax('get_standards_aligned_assets', payload, result=>{
				U.loading_stop()
				this.standards_aligned_assets_loading = false

				for (let unit of this.units) {
					if (unit.standards_aligned_assets_loaded) continue
					// note that a given resource/lesson may be represented multiple times in standards_aligned_assets
					if (result.lessons) for (let lesson_data of result.lessons) {
						// TEMP: remove "Imported - " at the start of the title
						lesson_data.lesson_title = lesson_data.lesson_title.replace(/^IMPORTED - /, '')
						let l = new Lesson(lesson_data)
						for (let saa of unit.standards_aligned_assets) {
							if (saa.asset_type == 'lesson' && saa.asset_id == lesson_data.lesson_id) vapp.$set(saa, 'lesson', l)
						}
					}

					if (result.resources) for (let resource_data of result.resources) {
						// TEMP: remove "Imported - " at the start of the title
						resource_data.description = resource_data.description.replace(/^IMPORTED - /, '')
						let r = new Resource(resource_data)
						for (let saa of unit.standards_aligned_assets) {
							if (saa.asset_type == 'resource' && saa.asset_id == resource_data.resource_id) vapp.$set(saa, 'resource', r)
						}
					}

					unit.standards_aligned_assets_loaded = true
				}
				resolve()
			})
		})
	}
}
window.Learning_Progression = Learning_Progression

// Legacy; no longer used
// class LP_Term {
// 	constructor(data) {
// 		if (empty(data)) data = {}
// 		sdp(this, data, 'title', '')
//
// 		this.units = []
// 		if (!empty(data.units)) {
// 			for (let u of data.units) {
// 				this.units.push(new LP_Unit(u))
// 			}
// 		}
// 	}
//
// 	copy_for_save() {
// 		let o = $.extend(true, {}, this)
// 		o.units = []
// 		for (let unit of this.units) {
// 			o.units.push(unit.copy_for_save())
// 		}
// 		return o
// 	}
// }
// window.LP_Term = LP_Term

class LP_Unit {
	constructor(data) {
		if (empty(data)) data = {}
		sdp(this, data, 'lp_unit_id', 0)

		// note: "shadow" units are currently not ever saved (though we might save them in the future)
		sdp(this, data, 'shadows_lp_id', 0)
		sdp(this, data, 'shadows_lp_unit_id', 0)
		sdp(this, data, 'shadow_unit_owner_id', 0)

		// for courses, we originally (and unfortunately) coded "Unit 1" in "title" and "The Civil War" in "description"; whereas for repos we coded the actual title in title.
		// as of 11/2023, we're re-coding so that the title is always in the title, and the number is in display_number
		// in course units, title -> display_number and description -> title
		if (data.display_number === undefined && !empty(data.description)) {
			data.display_number = data.title
			data.title = data.description
		}

		sdp(this, data, 'title', '')
		sdp(this, data, 'display_number', '')
		sdp(this, data, 'duration', '0')	// as of June 2023, durations can be strings

		sdp(this, data, 'text', '')

		sdp(this, data, 'is_flex_unit', 0)
		sdp(this, data, 'instance_unit_of', 0)

		// used in Collection.vue; removed before saving
		sdp(this, data, 'full_description_showing', false)
		sdp(this, data, 'full_description_height', -1)

		// assets (lessons, resources, activities) aligned to this unit's standards, which might or might not be explicitly loaded in resources[] or lessons[]
		// each object in this array will have these properties: asset_type, asset_id, cfitem_identifier, is_secondary
		sdp(this, data, 'standards_aligned_assets', [])
		sdp(this, data, 'standards_aligned_assets_loading', false)
		sdp(this, data, 'standards_aligned_assets_loaded', false)

		sdp(this, data, 'standard_showing', {})
		sdp(this, data, 'standard_resources_showing', {})
		sdp(this, data, 'standard_secondary_resources_showing', {})

		// in flex units, we allow the limitation of supported content types per instance
		sdp(this, data, 'excluded_content_types', [])

		this.standards = []
		if (!empty(data.standards)) {
			for (let standard of data.standards) {
				this.standards.push(new CASE_Item(standard))
			}
		}

		// individual resources associated with the unit; put them in the order matching resource_ids if we have them; otherwise use the original order
		this.resources = []
		if (!empty(data.resources)) {
			if (!empty(data.resource_ids)) {
				if (data.resources.length != data.resource_ids.length) console.warn(`unit ${this.title}: ${data.resources.length} resources / ${data.resource_ids.length} resource_ids`)
				for (let resource_id of data.resource_ids) {
					let r = data.resources.find(x=>x.resource_id==resource_id)
					if (!r) {
						// shouldn't happen, but just in case...
						console.log('couldn’t find resource for resource_id ' + resource_id)
					} else if (this.resources.find(x=>x.resource_id == r.resource_id)) {
						console.log(`duplicate resource_id ${r.resource_id} in unit ${this.lp_unit_id}`)
					} else {
						r = new Resource(r)
						// skip items the user doesn't have access to
						if (r.is_visible_by_user()) this.resources.push(r)
					}
				}
			} else {
				for (let r of data.resources) {
					// skip items the user doesn't have access to
					if (r.is_visible_by_user()) this.resources.push(new Resource(r))
				}
			}
		}

		// lessons associated with the unit
		this.lessons = []
		if (!empty(data.lessons)) {
			if (!empty(data.lesson_ids)) {
				if (data.lessons.length != data.lesson_ids.length) console.warn(`unit ${this.title}: ${data.lessons.length} lessons / ${data.lesson_ids.length} lesson_ids`)
				for (let lesson_id of data.lesson_ids) {
					let r = data.lessons.find(x=>x.lesson_id==lesson_id)
					if (!r) {
						// shouldn't happen, but just in case...
						console.log('couldn’t find lesson for lesson_id ' + lesson_id)
					} else if (this.lessons.find(x=>x.lesson_id == r.lesson_id)) {
						console.log(`duplicate lesson_id ${r.lesson_id} in unit ${this.lp_unit_id}`)
					} else {
						r = new Lesson(r)
						// skip items the user doesn't have access to
						if (r.is_visible_by_user()) this.lessons.push(r)
					}
				}
			} else {
				for (let r of data.lessons) {
					// skip items the user doesn't have access to
					if (r.is_visible_by_user()) this.lessons.push(new Lesson(r))
				}
			}
		}

		// Note: old HC has 'activities' too...
		
		// this structure marks parts (e.g. "folders") of TCC resource collections that are to be highlighted for this unit
		// the structure is an object, with one member per collection (identified by the collection's resource_id),
		// which includes an array of resource "folder" id's (or potentially resource_ids from actual resources) that are to be included
		// This is legacy data from Henry; in cureum we transfer the tcc data to the course collection units in Collection.create_folders_for_legacy_courses,
		// and we allow for new tcc folders to be created in CollectionUnitEdit.add_resource_collection_folder
		this.resource_collection_inclusions = {}
		if (!empty(data.resource_collection_inclusions)) {
			for (let rcid in data.resource_collection_inclusions) {
				this.resource_collection_inclusions[rcid] = data.resource_collection_inclusions[rcid].concat([])
			}
		}

		// this structure is for holding the tree structure for resources in the unit
		this.resource_tree = {folders: [], folder_assignments:[], folder_hash:{}}
		if (!empty(data.resource_tree)) {
			// this.resource_tree = $.extend(true, {}, data.resource_tree)
			let found_top = false
			let added_folders = new Set()
			for (let folder of data.resource_tree.folders) {
				if (!added_folders.has(folder.folder_id)) {
					this.create_resource_folder(folder)
					added_folders.add(folder.folder_id)
					if (folder.folder_id == 'top') found_top = true
				}
			}

			// create a top folder if necessary (it shouldn't be necessary, but just in case...)
			if (!found_top) this.create_resource_folder({folder_id: 'top', title: '', parent_folder_id: '', seq: 0})

			let placed_resource_ids = []
			for (let folder_assignment of data.resource_tree.folder_assignments) {
				// only place each item once; bugs could creep in that would lead to spurious folder_assignments
				if (placed_resource_ids.includes(folder_assignment.resource_id)) {
					console.log('spurious folder_assignment ignored', folder_assignment)
					continue
				}

				// check for, and skip, spurious folder_assignments for resources and lessons
				if (folder_assignment.type == 'resource' && !this.resources.find(x=>x.resource_id == folder_assignment.resource_id)) {
					// console.log('skipping bad resource folder assignment', folder_assignment)
					continue
				}
				if (folder_assignment.type == 'lesson' && !this.lessons.find(x=>x.lesson_id == folder_assignment.resource_id)) {
					// console.log('skipping bad lesson folder assignment', folder_assignment)
					continue
				}
				
				this.add_item_to_folder(folder_assignment)
				placed_resource_ids.push(folder_assignment.resource_id)
			}
		} else {
			// if we didn't already have a resource_tree, start with a top folder
			this.create_resource_folder({folder_id: 'top', title: '', parent_folder_id: '', seq: 0})
		}

		// data recorded if we use the BulkActivityImport interface with the unit
		sdp(this, data, 'bulk_import_collection_data', null)
	}

	copy_for_save() {
		let o = $.extend(true, {}, this)

		// remove these things that are used in Collection.vue
		delete o.full_description_showing
		delete o.full_description_height
		delete o.standard_children_showing
		delete o.standard_resources_showing
		delete o.standard_secondary_resources_showing

		// remove standards_aligned_assets
		delete o.standards_aligned_assets
		delete o.standards_aligned_assets_loaded
		delete o.standards_aligned_assets_loading

		// if we haven't excluded any content types, not save this setting
		// (currently only applies to flex units)
		if (!o.excluded_content_types || o.excluded_content_types.length < 1) delete o.excluded_content_types

		// remove full resource objects; attach resource_ids instead
		delete o.resources
		o.resource_ids = []
		for (let r of this.resources) {
			// skip 'placeholder' resources from CollectionResourceFolder
			if (r.placeholder === true) continue

			// and skip resources from tcc's
			if (r.tcc_folder_id) continue
			
			o.resource_ids.push(r.resource_id)
		}
		// remove full lesson objects; attach lesson_ids instead
		delete o.lessons
		o.lesson_ids = []
		for (let r of this.lessons) {
			o.lesson_ids.push(r.lesson_id)
		}

		for (let i = 0; i < this.standards.length; ++i) {
			o.standards[i] = o.standards[i].copy_for_save()
		}

		// remove resource_tree if there aren't any folder_assignments or folders (keeping in mind that there will always be a 'top' folder)
		if (o.resource_tree.folder_assignments.length == 0 && o.resource_tree.folders.length < 2) {
			delete o.resource_tree
		} else {
			// else save them; code here is in case we later need to exclude some temporary folders/folder assignments
			let resource_tree = { folder_assignments: [], folders: [] }		// don't save folder_hash
			for (let folder of o.resource_tree.folders) {
				if (folder.tcc_folder_id) continue
				delete folder.tcc_loaded	// delete tcc_loaded flag if there
				delete folder.has_rcis		// delete has_rcis flag if there
				delete folder.children
				// delete folder.children_calculated
				resource_tree.folders.push(folder)
			}
			for (let folder_assignment of o.resource_tree.folder_assignments) {
				if (folder_assignment.tcc_folder_id) continue
				if (folder_assignment.placeholder) continue	// skip placeholder assignments
				resource_tree.folder_assignments.push(folder_assignment)
			}
			o.resource_tree = resource_tree
		}

		// if a create_standards_tree_from_standard was added, send it through (see CollectionEdit.vue)
		if (!empty(this.create_standards_tree_from_standard)) o.create_standards_tree_from_standard = this.create_standards_tree_from_standard

		// console.log('copy_for_save', o)

		return o
	}

	// note that there is also a version of this for the whole lp
	get_standards_aligned_assets() {
		return new Promise((resolve, reject) => {
			// if already loaded, or we're already loading, return
			if (this.standards_aligned_assets_loaded || this.standards_aligned_assets_loading) {
				resolve()
				return
			}

			// set standards_aligned_assets_loading right away
			this.standards_aligned_assets_loading = true

			let payload = {user_id: vapp.user_info.user_id, lesson_ids: [], resource_ids: []}
			// get lists of assets to load
			for (let asset of this.standards_aligned_assets) {
				if (asset.asset_type == 'lesson') payload.lesson_ids.push(asset.asset_id)
				else payload.resource_ids.push(asset.asset_id)
			}

			// remove duplicates
			payload.lesson_ids = JSON.stringify([...new Set(payload.lesson_ids)])
			payload.resource_ids = JSON.stringify([...new Set(payload.resource_ids)])

			U.loading_start()
			U.ajax('get_standards_aligned_assets', payload, result=>{
				U.loading_stop()
				// console.log(result)

				// note that a given resource/lesson may be represented multiple times in standards_aligned_assets
				if (result.lessons) for (let lesson_data of result.lessons) {
					// TEMP: remove "Imported - " at the start of the title
					lesson_data.lesson_title = lesson_data.lesson_title.replace(/^IMPORTED - /, '')
					let l = new Lesson(lesson_data)
					for (let saa of this.standards_aligned_assets) {
						if (saa.asset_type == 'lesson' && saa.asset_id == lesson_data.lesson_id) vapp.$set(saa, 'lesson', l)
					}
				}

				if (result.resources) for (let resource_data of result.resources) {
					// TEMP: remove "Imported - " at the start of the title
					resource_data.description = resource_data.description.replace(/^IMPORTED - /, '')
					let r = new Resource(resource_data)
					for (let saa of this.standards_aligned_assets) {
						if (saa.asset_type == 'resource' && saa.asset_id == resource_data.resource_id) vapp.$set(saa, 'resource', r)
					}
				}

				this.standards_aligned_assets_loaded = true
				resolve()
			})
		})
	}

	get_max_folder_sequence(folder_id) {
		// look through folder_assignments and folders, and get the max seq value for items connected to the given folder_id
		let last_seq = -1
		for (let fa of this.resource_tree.folder_assignments) {
			if (fa.parent_folder_id == folder_id && fa.seq > last_seq) {
				last_seq = fa.seq
			}
		}
		for (let folder of this.resource_tree.folders) {
			if (folder.parent_folder_id == folder_id && folder.seq > last_seq) {
				last_seq = folder.seq
			}
		}

		// if last_seq is < the given folder's (children.length - 1), use children.length - 1
		let folder = this.resource_tree.folder_hash[folder_id]
		if (folder && last_seq < (folder.children.length - 1)) {
			last_seq = folder.children.length - 1
		}
		return last_seq
	}

	// old fn signature: create_resource_folder(parent_folder_id, folder_title, folder_items, folder_color, folder_id) {
	create_resource_folder(params) {
		let folder_id = (empty(params.folder_id)) ? U.new_uuid() : params.folder_id
		let folder_items = (empty(params.items)) ? [] : params.items
		let seq = (!empty(params.seq)) ? params.seq : (this.get_max_folder_sequence(params.parent_folder_id) + 1)

		// create the folder
		let f = {
			folder_id: folder_id,
			title: params.title,
			color: params.color ?? '',
			parent_folder_id: params.parent_folder_id,
			seq: seq,
			rcis: {},
			children: [],
		}

		// allow for cross_unit_key on top-level items
		if (params.parent_folder_id == 'top') {
			f.cross_unit_key = params.cross_unit_key ?? ''
		}

		// structure for holding tcc items to be included in the folder ("resource_collection_inclusions")
		if (!empty(params.rcis)) {
			for (let rcid in params.rcis) {
				f.rcis[rcid] = params.rcis[rcid].concat([])
				f.has_rcis = true	// this will be removed before saving
			}
		}

		// when we render a tcc collection in a folder, we temporarily add the tcc resources, folders, and folder assignments based on the base folder's `rcis` value, and set .tcc to 1 for all these added entities; 
		// then when we save we leave these items out of the saved unit data, and re-add them on the fly whenever the unit is viewed
		if (params.tcc_folder_id) f.tcc_folder_id = params.tcc_folder_id
		if (params.tcc_loaded) f.tcc_loaded = true

		// add folder to resource_tree.folders
		this.resource_tree.folders.push(f)

		// add folder to resource_tree.folder_hash; this has to be done with vue.set
		vapp.$set(this.resource_tree.folder_hash, folder_id, f)

		// then add any supplied folder_items to the folder
		for (let i = 0; i < folder_items.length; ++i) {
			this.add_item_to_folder({item:folder_items[i], parent_folder_id: folder_id, seq:i, tcc_folder_id:params.tcc_folder_id})
		}

		return f
	}

	add_item_to_folder(params) {
		let type, resource_id, parent_folder_id, seq
		let fa = {}

		// if params doesn't include an item value, it is an existing folder_assignment record that we're copying over
		if (empty(params.item)) {
			fa.parent_folder_id = empty(params.parent_folder_id) ? '' : params.parent_folder_id
			fa.type = empty(params.type) ? 'resource' : params.type
			fa.resource_id = empty(params.resource_id) ? '' : params.resource_id
			fa.seq = empty(params.seq) ? 0 : params.seq

		// else get the folder_assignment data from the item
		} else {
			// required params: item, parent_folder_id
			// optional params: seq, tcc_folder_id
			fa.parent_folder_id = params.parent_folder_id
			fa.type = (params.item.lesson_id) ? 'lesson' : 'resource'
			fa.resource_id = (params.item.lesson_id) ? params.item.lesson_id : params.item.resource_id
			fa.seq = (!empty(params.seq)) ? params.seq : (this.get_max_folder_sequence(fa.parent_folder_id) + 1)
		}

		let folder = this.resource_tree.folder_hash[params.parent_folder_id]
		if (empty(folder)) {
			console.log(`add_item_to_folder: invalid parent_folder_id ${params.parent_folder_id}`)
			return
		}

		if (params.placeholder) fa.placeholder = params.placeholder	// marker for placeholder resource folder_assignments
		if (params.tcc_folder_id) fa.tcc_folder_id = params.tcc_folder_id	// see above

		folder.children.push(fa.resource_id)
		this.resource_tree.folder_assignments.push(fa)
		// MC: Shouldn't this function also add the resource/lesson to the unit's resource/lesson object if it isn't already there?

		return fa
	}

	// get a list of all items (lessons and resources, not folders) in top_folder_id and its descendent folders
	items_in_folder_recursive(top_folder_id) {
		let arr = []
		let get_children = (folder_id) => {
			let folder = this.resource_tree.folder_hash[folder_id]
			for (let child_resource_id of folder.children) {
				let child_folder = this.resource_tree.folder_hash[child_resource_id]
				if (child_folder) {
					get_children(child_resource_id)
				} else {
					arr.push(child_resource_id)
				}
			}
		}
		if (!this.resource_tree.folder_hash[top_folder_id]) {
			console.warn('bad top_folder_id: ' + top_folder_id)
			return []
		}
		get_children(top_folder_id)
		return arr
	}

	// remove an item from the unit, also taking care of the folder and folder assignment
	remove_item(params) {
		// get item_id, which could be a resource_id or lesson_id, and can be specified a few different ways
		let item_id
		if (params.item) {
			if (params.item.item_id) item_id = params.item.item_id
			else if (params.item.resource_id) item_id = params.item.resource_id
			else if (params.item.lesson_id) item_id = params.item.lesson_id
		} else {
			if (params.item_id) item_id = params.item_id
			else if (params.resource_id) item_id = params.resource_id
			else if (params.lesson_id) item_id = params.lesson_id
		}

		// remove item from resources or lessons
		let rindex = this.resources.findIndex(x=>x.resource_id == item_id)
		if (rindex > -1) this.resources.splice(rindex, 1)

		let lindex = this.lessons.findIndex(x=>x.lesson_id == item_id)
		if (lindex > -1) this.lessons.splice(lindex, 1)

		// for now at least we're not allowing the same item to be multiple places in the unit (except for within TCC trees, which we don't use remove_item to deal with)
		let faindex
		do {
			faindex = this.resource_tree.folder_assignments.findIndex(x=>x.resource_id==item_id)
			if (faindex > -1) {
				let fa = this.resource_tree.folder_assignments[faindex]
				// remove from the folder's "children" array
				let folder = this.resource_tree.folder_hash[fa.parent_folder_id]
				if (folder) {
					let fi = folder.children.indexOf(item_id)
					if (fi > -1) folder.children.splice(fi, 1)
				}
				
				// splice from folder_assignments
				this.resource_tree.folder_assignments.splice(faindex, 1)
			}
		} while (faindex > -1)
	}
}
window.LP_Unit = LP_Unit

// THIS CLASS IS DEFUNCT AS OF 10/12/2024 -- replaced with CASE_Items
// a LP standard has a case identifier, a case_item, associated text, and any number of associated resources
// class LP_Unit_Standard {
// 	constructor(data) {
// 		if (empty(data)) data = {}

// 		sdp(this, data, 'text', '')
// 		sdp(this, data, 'identifier', '')
// 		this.case_item = new CASE_Item(data.case_item)
// 		this.resources = []
// 		if (!empty(data.resources)) {
// 			for (let r of data.resources) {
// 				this.resources.push(new Resource(r))
// 			}
// 		}
// 	}

// 	copy_for_save() {
// 		let o = $.extend(true, {}, this)

// 		// remove full resource objects; attach resource_ids instead
// 		delete o.resources
// 		o.resource_ids = []
// 		for (let r of this.resources) {
// 			o.resource_ids.push(r.resource_id)
// 		}

// 		return o
// 	}
// }
// window.LP_Unit_Standard = LP_Unit_Standard

// NOTE: we previously used an `LP_Unit_Standard` construct, that in turn included a CASE_Item
class CASE_Item {
	constructor(data, framework_identifier) {
		if (empty(data)) data = {}

		// data may include a cfitem property, along with optional framework_identifier, childOf, and sequenceNumber values
		if (!empty(data.cfitem)) {
			// in this case, normalize the data property to include the extra values for our purposes below
			let o = object_copy(data.cfitem)
			o.framework_identifier = data.framework_identifier
			o.childOf = data.childOf
			o.sequenceNumber = data.sequenceNumber
			data = o
		} 
		
		// or constructor can receive a separate framework_identifier; this allows us to receive a "raw" CASE CFItem as data, with the framework_identifier sent separately
		if (!empty(framework_identifier)) this.framework_identifier = framework_identifier
		else if (!empty(data.framework_identifier)) this.framework_identifier = data.framework_identifier
		else this.framework_identifier = ''

		sdp(this, data, 'identifier', '')
		sdp(this, data, 'lastChangeDateTime', '')

		sdp(this, data, 'humanCodingScheme', '')
		sdp(this, data, 'fullStatement', '')
		sdp(this, data, 'educationLevel', [])

		// recode CASE educationLevel to grade_low/grade_high for convenience
		sdp(this, data, 'grade_low', '')
		sdp(this, data, 'grade_high', '')
		if (empty(data.grade_low) && !empty(data.educationLevel)) {
			this.code_grades_from_education_level(data.educationLevel)
		}

		// cfitem_identifier for the parent of this item, and sequenceNumber; harvested from the item's isChildOf association
		sdp(this, data, 'childOf', '')
		sdp(this, data, 'sequenceNumber', 0)

		// sourceItemIdentifier, which we might need later; might be in extensions, if we got the data directly from satchel
		if (!empty(data.sourceItemIdentifier)) this.sourceItemIdentifier = data.sourceItemIdentifier
		else if (!empty(data.extensions?.sourceItemIdentifier)) this.sourceItemIdentifier = data.extensions.sourceItemIdentifier
		else this.sourceItemIdentifier = ''

		// this structure holds data about a CASE item, but practically, we use arrays this class to represent sets of standards that *align* with an asset (resource, lesson, or lp_unit)
		// we allow here for representing a "is_secondary" flag for these alignments
		sdp(this, data, 'is_secondary', false)

		// rather than using separate CASE associations, we'll just use recursive arguments to code is_child_of relationships
		// however, note that for curriculum maps, we don't currently "nest" CASE items in any case
		this.children = []
		if (!empty(data.children)) {
			for (let c of data.children) {
				this.children.push(new CASE_Item(c))
			}
		}
	}

	copy_for_save() {
		// note: send null values for some things, so that we don't save unnecessary fields in the DB
		return {
			framework_identifier: this.framework_identifier,
			identifier: this.identifier,
			lastChangeDateTime: this.lastChangeDateTime,
			humanCodingScheme: this.humanCodingScheme,
			fullStatement: this.fullStatement,
			educationLevel: this.educationLevel,
			childOf: this.childOf,
			sequenceNumber: this.sequenceNumber,
			sourceItemIdentifier: this.sourceItemIdentifier || null,
			is_secondary: this.is_secondary ? 1 : 0,
		}
	}

	code_grades_from_education_level(el) {
		if (empty(el)) el = this.educationLevel
		let gvl = 10000
		let gvh = -10000
		this.grade_low = ''
		this.grade_high = ''
		for (let g of el) {
			if (g == 'KG') g = 'K'
			else if (!isNaN(g*1)) g = g*1+''
			else {
				console.log('unknown grade: ' + g)
				continue
			}
			let gv = U.grade_value(g)
			if (gv < gvl) {
				gvl = gv
				this.grade_low = g
			}
			if (gv > gvh) {
				gvh = gv
				this.grade_high = g
			}
		}
		return [this.grade_low, this.grade_high]
	}

	code_education_level_from_grades(grade_low, grade_high) {
		if (empty(grade_low)) {
			grade_low = this.grade_low
			grade_high = this.grade_high
		}

		let el = []
		if (this.grade_low) {
			let i = U.grade_value(this.grade_low)
			let end = U.grade_value(this.grade_high)
			for (; i <= end; ++i) {
				el.push(vapp.$store.state.grades[i])
			}
		}
		this.educationLevel = el
		return el
	}

	convert_to_sparkl_format() {
		// convert to the format Sparkl expects...
		let o = {
			framework_identifier: this.framework_identifier,
			cfitem: {
				// note that this is not an exhaustive list of CASE data, but it has the essentials
				identifier: this.identifier,
				uri: this.uri,
				humanCodingScheme: this.humanCodingScheme,
				fullStatement: this.fullStatement,
				educationLevel: this.educationLevel,
			}
		}
		return o
	}

	btn_color(arr) {
		// our standard way of showing standards is to use the 'primary' color by default, or gray for secondary alignments
		if (this.is_secondary) return '#666'
		return 'primary'
	}

	// this is used in SparklEmbed to convert incoming data from Sparkl about alignments to the CASE_Item format we use in Cureum
	static convert_from_sparkl_format(case_alignments) {
		// allow case_alignments to be an object or an array of objects
		if (!$.isArray(case_alignments)) case_alignments = [case_alignments]
		let arr = []
		for (let ca of case_alignments) {
			arr.push({
				framework_identifier: ca.framework_identifier,
				identifier: ca.cfitem.identifier,
				lastChangeDateTime: ca.cfitem.lastChangeDateTime,
				humanCodingScheme: ca.cfitem.humanCodingScheme ?? '',
				fullStatement: ca.cfitem.fullStatement,
				educationLevel: ca.cfitem.educationLevel ?? [],
				// note that we probably won't get childOf and sequenceNumber fom Sparkl
				childOf: ca.childOf ?? '',
				sequenceNumber: ca.sequenceNumber ?? 0,
			})
		}
		return arr
	}

}
window.CASE_Item = CASE_Item
